const getLastArrayElement = (array: any[]) => {
	return array?.[(array?.length ?? 0) - 1] ?? null
}

export default getLastArrayElement
